export enum BrowserEnv {
    Browser = 'browser',
    Server = 'server',
}

export enum DeploymentEnv {
    Dev = 'dev',
    Test = 'test',
    Staging = 'staging',
    Production = 'prod',
}

export enum APIEnv {
    Test = 'test',
    Production = 'prod',
}
